module.exports = __webpack_public_path__ + "assets/img/tob-tech-icon.72d42626.svg";